/* eslint-disable */
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import Loader from '../../../../components/Loader/Loader';
import { Box, Typography } from '@material-ui/core';
import MaterialTable from 'material-table';
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import useStyles from '../../Main.style';

const SummaryInvoiceByCell = ({
  reportArr,
  myCellInvoiceArray,
  myProfitRevenue,
  dashboardComments,
  dashboardSectionText,
}) => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const [pastDueInvoicesObject, setPastDueInvoicesObject] = useState([]);
  const [profitInvoicesObject, setProfitInvoicesObject] = useState([]);
  const [revenueInvoicesObject, setRevenueInvoicesObject] = useState([]);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const [cellDetails] = useState(loggedInUserData['cell']);
  const [isLoaded] = useState(true);

  const fillPastDueTotals = useCallback(async (reportArr) => {
    reportArr.sort((a, b) => {
      const totalA = parseFloat(a.totalDue);
      const totalB = parseFloat(b.totalDue);

      if (totalA > totalB) {
        return -1;
      }
      if (totalA < totalB) {
        return 1;
      }
      return 0;
    });
    //Ranking logic for past due
    let rankingIncr = 0;
    reportArr.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        rankingIncr = rankingIncr + 1;
        obj.rank = rankingIncr;
      }
    });

    //Ranking logic
    await setPastDueInvoicesObject(reportArr);
  });

  const fillProfit = async ({ reportArr }) => {
    reportArr.sort((a, b) => {
      const totalA = parseFloat(a.profit);
      const totalB = parseFloat(b.profit);

      if (totalA > totalB) {
        return -1;
      }
      if (totalA < totalB) {
        return 1;
      }
      return 0;
    });
    //Ranking logic for past due
    let rankingIncr = 0;
    reportArr.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        rankingIncr = rankingIncr + 1;
        obj.rank = rankingIncr;
      }
    });
    //Ranking logic
    setProfitInvoicesObject(reportArr);
  };

  const fillRevenue = async ({ reportArr }) => {
    reportArr.sort((a, b) => {
      const totalA = parseFloat(a?.revenue);
      const totalB = parseFloat(b?.revenue);

      if (totalA > totalB) {
        return -1;
      }
      if (totalA < totalB) {
        return 1;
      }
      return 0;
    });
    //Ranking logic for past due
    let rankingIncr = 0;
    reportArr.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        rankingIncr = rankingIncr + 1;
        obj.rank = rankingIncr;
      }
    });
    //Ranking logic
    setRevenueInvoicesObject(reportArr);
  };
  const formatToCustomNumber = (data, styles, type) => {
    if (data === null) {
      return 'N/A';
    }

    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-${Math.abs(numberData)})`;
      return <Typography className={styles.TableTextRed}>{formattedValue + ' ' + type}</Typography>;
    }
    // Format positive numbers normally
    return `${numberData} ${type}`;
  };
  const formatToCustomerCurrency = (data, styles, type) => {
    if (data === null) {
      return 'N/A';
    }
    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-$${Math.abs(numberData).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
      return <Typography className={styles.TableTextRed}>{formattedValue + ' ' + type}</Typography>;
    }
    // Format positive numbers normally
    return `$${numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} ${type}`;
  };

  const formatToCurrency = (data, styles) => {
    if (data === null) {
      return 'N/A';
    }
    if (!data || data?.length === 0) {
      return 'N/A';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-$${Math.abs(numberData).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
      return (
        <Typography className={styles ? styles.TableTextRed : ''}>{formattedValue}</Typography>
      );
    }
    // Format positive numbers normally
    return `$${numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  useEffect(() => {
    fillPastDueTotals(reportArr);
  }, [fillPastDueTotals, reportArr]);

  useEffect(() => {
    fillRevenue({ reportArr });
  }, []);

  useEffect(() => {
    fillProfit({ reportArr });
  }, []);

  return (
    <>
      <If condition={!isLoaded}>
        <Loader />
      </If>
      <If condition={isLoaded}>
        {/* PROFIT COMPONENT */}
        <Box mt={1} className={classes.TableUIV2}>
          <MaterialTable
            style={{ boxShadow: 'none' }}
            options={{
              toolbar: false,
              draggable: false,
              paging: false,
              sorting: true,
              pageSize: 20,
              pageSizeOptions: [10, 20, 50, 100],
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'right',
              showFirstLastPageButtons: false,
              actionsColumnIndex: -100,
              emptyRowsWhenPaging: false,
            }}
            localization={{
              pagination: {
                labelRowsSelect: 'Rows',
                labelRowsPerPage: 'Rows Per Page',
              },
            }}
            title="Invoicing"
            columns={[
              {
                title: 'Cell ' + cellDetails?.['cellTitle'],
                field: 'cellf',
              },
              {
                title: new Date().getFullYear() + ' YTD',
                field: 'ytd',
              },
              {
                title: 'Ranking',
                field: 'vectorranking',
                cellStyle: {
                  textAlign: 'right',
                },
                render: (rowData) => (
                  <span
                    className={
                      rowData?.vectorranking ==
                      Math.max(...myCellInvoiceArray.map((o) => o?.vectorranking))
                        ? classes.vectorRankingRed
                        : rowData?.vectorranking == 1
                        ? classes.vectorRankingGreen
                        : classes.vectorranking
                    }
                  >
                    {rowData?.vectorranking}
                  </span>
                ),
              },
              {
                title: 'Top Cell',
                field: 'bestcell',
              },
              {
                title: 'Last Year',
                field: 'previousyear',
              },
            ]}
            data={[
              {
                //cellf: 'Revenue',
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Revenue"
                    title={dashboardSectionText}
                  />
                ),
                ytd: formatToCurrency(myProfitRevenue?.revenueValueByCell, classes),
                vectorranking: (() => {
                  const currentYear = moment().year();
                  let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                  // Filter the array with the condition
                  const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                  );

                  // Sort the filtered array in descending order based on the 'current' property
                  const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                    return (parseFloat(b?.revenue) || 0) - (parseFloat(a?.revenue) || 0);
                  });

                  // Find the index of the object that matches the condition
                  const index = sortedPastDueInvoices.findIndex(
                    (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                  );

                  return index === -1 ? 'N/A' : index + 1;
                })(),

                bestcell: formatToCurrency(
                  pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                    const currentYear = moment().year();
                    const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                    if (reportYear === currentYear) {
                      const currentValue = parseFloat(currentObj?.revenue) || 0;
                      const maxValue = parseFloat(maxObj?.revenue) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }
                    return maxObj;
                  }, {})?.revenue,
                ),
                previousyear: formatToCurrency(myProfitRevenue.revenuePrevYearValueByCell, classes),
              },
              {
                //Revenue Target data
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Revenue Target"
                    title={dashboardSectionText}
                  />
                ),

                ytd: formatToCurrency(myCellInvoiceArray[0]?.ytd, classes),
                vectorranking: myCellInvoiceArray[0] ? myCellInvoiceArray[0]?.vectorRank : '',

                bestcell: formatToCurrency(myCellInvoiceArray[0]?.bestCell, classes),

                previousyear: formatToCurrency(myCellInvoiceArray[0]?.prevYear, classes),
              },
              {
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Gross Profit"
                    title={dashboardSectionText}
                  />
                ),
                ytd: formatToCurrency(myProfitRevenue?.profitValueByCell, classes),
                vectorranking: (() => {
                  const currentYear = moment().year();
                  let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                  // Filter the array with the condition
                  const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                  );

                  // Sort the filtered array in descending order based on the 'current' property
                  const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                    return (parseFloat(b?.profit) || 0) - (parseFloat(a?.profit) || 0);
                  });

                  // Find the index of the object that matches the condition
                  const index = sortedPastDueInvoices.findIndex(
                    (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                  );

                  return index === -1 ? 'N/A' : index + 1;
                })(),
                bestcell: formatToCurrency(
                  pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                    const currentYear = moment().year();
                    const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                    if (reportYear === currentYear) {
                      const currentValue = parseFloat(currentObj?.profit) || 0;
                      const maxValue = parseFloat(maxObj?.profit) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }
                    return maxObj;
                  }, {})?.profit,
                ),
                previousyear: formatToCurrency(myProfitRevenue.profitPrevYearValueByCell, classes),
              },
              {
                //Gross Profit Target
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Gross Profit Target"
                    title={dashboardSectionText}
                  />
                ),

                ytd: formatToCurrency(myCellInvoiceArray[1]?.ytd, classes),
                vectorranking: myCellInvoiceArray[1] ? myCellInvoiceArray[1]?.vectorRank : '',

                bestcell: formatToCurrency(myCellInvoiceArray[1]?.bestCell, classes),

                previousyear: formatToCurrency(myCellInvoiceArray[1]?.prevYear, classes),
              },
              {
                //Average Gross Profit per File
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Average Gross Profit per File"
                    title={dashboardSectionText}
                  />
                ),
                ytd: formatToCustomerCurrency(myCellInvoiceArray[5]?.ytd, classes, ' /File'),
                vectorranking: myCellInvoiceArray[5] ? myCellInvoiceArray[5]?.vectorRank : '',

                bestcell: formatToCustomerCurrency(
                  myCellInvoiceArray[5]?.bestCell,
                  classes,
                  ' /File',
                ),

                previousyear: formatToCustomerCurrency(
                  myCellInvoiceArray[5]?.prevYear,
                  classes,
                  ' /File',
                ),
              },
              {
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Gross Profit Weighted for Complexity"
                    title={dashboardSectionText}
                  />
                ),
                ytd: formatToCurrency(myCellInvoiceArray[8]?.ytd, classes),
                vectorranking: myCellInvoiceArray[8] ? myCellInvoiceArray[8]?.vectorRank : '',

                bestcell: formatToCurrency(myCellInvoiceArray[8]?.bestCell, classes),

                previousyear: formatToCurrency(myCellInvoiceArray[8]?.prevYear, classes),
              },
              {
                //Active to Admin Delta

                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Active to Admin Delta"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  myCellInvoiceArray[3]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[3]?.ytd, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[3]?.ytd,
                        classes,
                        myCellInvoiceArray[3]?.type,
                      ),
                vectorranking: myCellInvoiceArray[3]?.vectorRank,
                bestcell:
                  myCellInvoiceArray[3]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[3]?.bestCell, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[3]?.bestCell,
                        classes,
                        myCellInvoiceArray[3]?.type,
                      ),
                previousyear:
                  myCellInvoiceArray[3]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[3]?.prevYear, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[3]?.prevYear,
                        classes,
                        myCellInvoiceArray[3]?.type,
                      ),
              },
              {
                //Admin to Closed Delta
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Admin to Closed Delta"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  myCellInvoiceArray[4]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[4]?.ytd, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[4]?.ytd,
                        classes,
                        myCellInvoiceArray[4]?.type,
                      ),
                vectorranking: myCellInvoiceArray[4]?.vectorRank,
                bestcell:
                  myCellInvoiceArray[4]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[4]?.bestCell, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[4]?.bestCell,
                        classes,
                        myCellInvoiceArray[4]?.type,
                      ),
                previousyear:
                  myCellInvoiceArray[4]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[4]?.prevYear, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[4]?.prevYear,
                        classes,
                        myCellInvoiceArray[4]?.type,
                      ),
              },
              {
                //Optimal Invoice Delta
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Optimal Invoice Delta"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  myCellInvoiceArray[2]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[2]?.ytd, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[2]?.ytd,
                        classes,
                        myCellInvoiceArray[2]?.type,
                      ),
                vectorranking: myCellInvoiceArray[2]?.vectorRank,

                bestcell:
                  myCellInvoiceArray[2]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[2]?.bestCell, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[2]?.bestCell,
                        classes,
                        myCellInvoiceArray[2]?.type,
                      ),
                previousyear:
                  myCellInvoiceArray[2]?.type == null
                    ? formatToCurrency(myCellInvoiceArray[2]?.prevYear, classes)
                    : formatToCustomNumber(
                        myCellInvoiceArray[2]?.prevYear,
                        classes,
                        myCellInvoiceArray[2]?.type,
                      ),
              },

              {
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Current (Not Yet Due)"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                    ?.current === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                          ?.current,
                        classes,
                      ) || 'N/A',

                vectorranking: (() => {
                  const currentYear = moment().year();
                  let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                  // Filter the array with the condition
                  const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                  );

                  // Sort the filtered array in descending order based on the 'current' property
                  const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                    return (parseFloat(b?.current) || 0) - (parseFloat(a?.current) || 0);
                  });

                  // Find the index of the object that matches the condition
                  const index = sortedPastDueInvoices.findIndex(
                    (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                  );

                  return index === -1 ? 'N/A' : index + 1;
                })(),
                bestcell: formatToCurrency(
                  pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                    const currentYear = moment().year();
                    const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                    if (reportYear === currentYear) {
                      const currentValue = parseFloat(currentObj?.current) || 0;
                      const maxValue = parseFloat(maxObj?.current) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }
                    return maxObj;
                  }, {})?.current,
                ),
                previousyear:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find(
                      (pi) =>
                        new Date(pi?.reportPeriod).getFullYear() ==
                        moment().subtract(1, 'year').year(),
                    )?.current === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find(
                            (pi) =>
                              new Date(pi?.reportPeriod).getFullYear() ==
                              moment().subtract(1, 'year').year(),
                          )?.current,
                        classes,
                      ) || 'N/A',
              },
              {
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="1 - 30 Days Past Due Amount"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                    ?.oneToThirty === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                          ?.oneToThirty,
                        classes,
                      ) || 'N/A',
                vectorranking: (() => {
                  const currentYear = moment().year();
                  let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                  // Filter the array with the condition
                  const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                  );

                  // Sort the filtered array in descending order based on the 'current' property
                  const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                    return (parseFloat(b?.oneToThirty) || 0) - (parseFloat(a?.oneToThirty) || 0);
                  });

                  // Find the index of the object that matches the condition
                  const index = sortedPastDueInvoices.findIndex(
                    (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                  );

                  return index === -1 ? 'N/A' : index + 1;
                })(),
                bestcell: formatToCurrency(
                  pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                    const currentYear = moment().year();
                    const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                    if (reportYear === currentYear) {
                      const currentValue = parseFloat(currentObj?.oneToThirty) || 0;
                      const maxValue = parseFloat(maxObj?.oneToThirty) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }
                    return maxObj;
                  }, {})?.oneToThirty,
                ),
                previousyear:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find(
                      (pi) =>
                        new Date(pi?.reportPeriod).getFullYear() ==
                        moment().subtract(1, 'year').year(),
                    )?.oneToThirty === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find(
                            (pi) =>
                              new Date(pi?.reportPeriod).getFullYear() ==
                              moment().subtract(1, 'year').year(),
                          )?.oneToThirty,
                        classes,
                      ) || 'N/A',
              },
              {
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="31+ Days Past Due amount"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                    ?.thirtyAndOver === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                          ?.thirtyAndOver,
                        classes,
                      ) || 'N/A',
                vectorranking: (() => {
                  const currentYear = moment().year();
                  let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                  // Filter the array with the condition
                  const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                  );

                  // Sort the filtered array in descending order based on the 'current' property
                  const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                    return (
                      (parseFloat(b?.thirtyAndOver) || 0) - (parseFloat(a?.thirtyAndOver) || 0)
                    );
                  });

                  // Find the index of the object that matches the condition
                  const index = sortedPastDueInvoices.findIndex(
                    (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                  );

                  return index === -1 ? 'N/A' : index + 1;
                })(),

                bestcell: formatToCurrency(
                  pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                    const currentYear = moment().year();
                    const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                    if (reportYear === currentYear) {
                      const currentThirtyAndOver = parseFloat(currentObj?.thirtyAndOver) || 0;
                      const maxThirtyAndOver = parseFloat(maxObj?.thirtyAndOver) || 0;
                      return currentThirtyAndOver > maxThirtyAndOver ? currentObj : maxObj;
                    }
                    return maxObj;
                  }, {})?.thirtyAndOver,
                ),

                previousyear:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find(
                      (pi) =>
                        new Date(pi?.reportPeriod).getFullYear() ==
                        moment().subtract(1, 'year').year(),
                    )?.thirtyAndOver === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find(
                            (pi) =>
                              new Date(pi?.reportPeriod).getFullYear() ==
                              moment().subtract(1, 'year').year(),
                          )?.thirtyAndOver,
                        classes,
                      ) || 'N/A',
              },
              {
                cellf: (
                  <InfoPopoverCommentsWrapper
                    dashboardComments={dashboardComments}
                    section="Overall Outstanding"
                    title={dashboardSectionText}
                  />
                ),
                ytd:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                    ?.totalDue === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find((pi) => new Date(pi?.reportPeriod).getFullYear() == moment().year())
                          ?.totalDue,
                        classes,
                      ) || 'N/A',
                vectorranking: (() => {
                  const currentYear = moment().year();
                  let pastDueInvoicesObjectCopy = [...pastDueInvoicesObject];
                  // Filter the array with the condition
                  const filteredPastDueInvoices = pastDueInvoicesObjectCopy.filter(
                    (pi) => new Date(pi?.reportPeriod).getFullYear() == currentYear,
                  );

                  // Sort the filtered array in descending order based on the 'current' property
                  const sortedPastDueInvoices = filteredPastDueInvoices.sort((a, b) => {
                    return (parseFloat(b?.totalDue) || 0) - (parseFloat(a?.totalDue) || 0);
                  });

                  // Find the index of the object that matches the condition
                  const index = sortedPastDueInvoices.findIndex(
                    (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                  );

                  return index === -1 ? 'N/A' : index + 1;
                })(),

                bestcell: formatToCurrency(
                  pastDueInvoicesObject.reduce((maxObj, currentObj) => {
                    const currentYear = moment().year();
                    const reportYear = new Date(currentObj?.reportPeriod).getFullYear();
                    if (reportYear === currentYear) {
                      const currentValue = parseFloat(currentObj?.totalDue) || 0;
                      const maxValue = parseFloat(maxObj?.totalDue) || 0;
                      return currentValue > maxValue ? currentObj : maxObj;
                    }
                    return maxObj;
                  }, {})?.totalDue,
                ),
                previousyear:
                  pastDueInvoicesObject
                    .filter((p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString())
                    .find(
                      (pi) =>
                        new Date(pi?.reportPeriod).getFullYear() ==
                        moment().subtract(1, 'year').year(),
                    )?.totalDue === undefined
                    ? 'N/A'
                    : formatToCurrency(
                        pastDueInvoicesObject
                          .filter(
                            (p) => cellDetails?.qbId && p.cellId == cellDetails?.qbId.toString(),
                          )
                          .find(
                            (pi) =>
                              new Date(pi?.reportPeriod).getFullYear() ==
                              moment().subtract(1, 'year').year(),
                          )?.totalDue,
                        classes,
                      ) || 'N/A',
              },
            ]}
          />
        </Box>
      </If>
    </>
  );
};

export default SummaryInvoiceByCell;
